import { PropsWithChildren, ReactElement } from 'react';

import { ArticleCard } from '../../article-card/article-card';
import { ArticleListItem } from '../../../models/article-list-item';
import { CardSlider, CardSliderProps } from '../card-slider';

export interface ArticleCardSliderProps
    extends PropsWithChildren,
        Pick<CardSliderProps<ArticleListItem>, 'showAllUrl' | 'title' | 'totalItems' | 'onLoadMore'> {
    articles: ArticleListItem[];
}

export const ArticleCardSlider = (props: ArticleCardSliderProps): ReactElement | null => {
    return (
        <CardSlider
            items={props.articles}
            renderComponent={item => <ArticleCard key={item.id} article={item} sx={{ maxWidth: '287px' }} />}
            title={props.title}
            showAllUrl={props.showAllUrl}
            totalItems={props.totalItems}
            onLoadMore={props.onLoadMore}
        />
    );
};
